const initUnderAgePopup = () => {
  const popup = document.querySelector(".under-age");
  const over21Btn = document.getElementById("btn-over21");

  if (!popup || !over21Btn) return;

  const hasConfirmed = sessionStorage.getItem("isOver21");
  const bypassPopup = window.location.search.includes("utm_term=gate") || false;

  if (!hasConfirmed && !bypassPopup) {
    popup.classList.add("visible");
  }

  if (bypassPopup) {
    sessionStorage.setItem("isOver21", "true");
  }

  over21Btn.addEventListener("click", () => {
    sessionStorage.setItem("isOver21", "true");
    popup.classList.remove("visible");
  });
};

export { initUnderAgePopup };
